import React from 'react';
import { AlertTriangle } from 'lucide-react';
import '../styles/Calculator.css';

// Compact consumption vs production meter. On desktop the same figures sit in
// the "Fiche & Bilan Énergétique" panel, so App only shows this below lg.
const EnergyStats = ({ production, consumption }) => {
  const isOver = consumption > production;
  const pct = production > 0 ? Math.min((consumption / production) * 100, 100) : 0;

  return (
    <section className={`energy-meter ${isOver ? 'is-over' : ''}`}>
      <div className="energy-meter__row">
        <span className="energy-meter__label">Votre consommation</span>
        <span className="energy-meter__value">
          {consumption.toLocaleString()} <small>/ {production.toLocaleString()} Wh par jour</small>
        </span>
      </div>
      <div
        className="energy-meter__track"
        role="progressbar"
        aria-label="Consommation par rapport à la production du pack"
        aria-valuenow={Math.round(pct)}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <span style={{ width: `${pct}%` }} />
      </div>
      {isOver && (
        <p className="energy-meter__alert">
          <AlertTriangle size={14} aria-hidden="true" />
          Votre consommation dépasse la production de ce pack.
        </p>
      )}
    </section>
  );
};

export default EnergyStats;
